import React from 'react';
import { CheckCircle2, XCircle, AlertTriangle } from 'lucide-react';

const NotificationToast = ({ notification, onClose }) => {
  if (!notification) return null;

  const icons = {
    success: <CheckCircle2 className="h-5 w-5 text-green-500" />,
    error: <XCircle className="h-5 w-5 text-red-500" />,
    warning: <AlertTriangle className="h-5 w-5 text-yellow-500" />
  };

  const bgColors = {
    success: 'bg-green-50 border-green-200',
    error: 'bg-red-50 border-red-200',
    warning: 'bg-yellow-50 border-yellow-200'
  };

  return (
    <div className={`fixed top-4 right-4 z-50 flex items-center gap-3 rounded-lg border p-4 shadow-lg ${bgColors[notification.type]}`}>
      {icons[notification.type]}
      <span className="text-sm font-medium">{notification.message}</span>
      <button 
        onClick={onClose}
        className="ml-2 text-gray-400 hover:text-gray-600"
      >
        <XCircle className="h-4 w-4" />
      </button>
    </div>
  );
};

export default NotificationToast;